import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d23d77a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1d23d77a&prod&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=1d23d77a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d23d77a",
  null
  
)

export default component.exports